import WebViewModal, {WebViewModalProps} from './WebViewModal';

export type {WebViewModalProps};
export default WebViewModal;
